import getEthereumProvider from "./get-ethereum-provider";
import { NO_PROVIDER, createWalletError } from "./wallet-error";

const getAddresses = async () => {
  const metamaskProvider = await getEthereumProvider();

  // detectEthereumProvider resolves to null when nothing injects in time, or
  // when another extension has taken over window.ethereum. Without this guard
  // the .request call below throws a TypeError that hides the real cause.
  if (!metamaskProvider) {
    throw createWalletError(
      NO_PROVIDER,
      "detectEthereumProvider() returned null - no injected wallet was found"
    );
  }

  return (
    (await metamaskProvider.request({
      method: "eth_requestAccounts",
    })) || []
  );
};

export default getAddresses;
